import { format, formatDistanceToNow, formatDistanceToNowStrict, isToday, isYesterday, isThisYear } from 'date-fns';

// ----------------------------------------------------------------------

const toValidDate = (date) => {
  if (date == null) return null;
  const d = new Date(date);
  return Number.isNaN(d.getTime()) ? null : d;
};

export function fDate(date) {
  const d = toValidDate(date);
  return d ? format(d, 'dd MMMM yyyy') : '';
}

export function fDateTime(date) {
  const d = toValidDate(date);
  return d ? format(d, 'dd MMM yyyy HH:mm') : '';
}

export function fDateTimeSuffix(date) {
  const d = toValidDate(date);
  return d ? format(d, 'dd/MM/yyyy hh:mm p') : '';
}

// Clock time only ("2:34 PM"). Chat threads pair this with a day divider, so
// repeating the date on every message group would be noise.
export function fTime(date) {
  const d = toValidDate(date);
  return d ? format(d, 'p') : '';
}

// Day-divider label for chat threads: Today / Yesterday / "12 June" (year
// only when it differs, because "12 June 2026" repeated down a thread is
// noise the reader has to skip).
export function fDayLabel(date) {
  const d = toValidDate(date);
  if (!d) return '';
  if (isToday(d)) return 'Today';
  if (isYesterday(d)) return 'Yesterday';
  return format(d, isThisYear(d) ? 'd MMMM' : 'd MMMM yyyy');
}

export function fToNow(date) {
  const d = toValidDate(date);
  return d ? formatDistanceToNow(d, { addSuffix: true }) : '';
}

export function relativeTime(d) {
  if (!d) return '';
  try { return formatDistanceToNowStrict(new Date(d), { addSuffix: true }); } catch { return ''; }
}
